import { useLanguage } from "@/context/LanguageContext";

const PrivacyPolicyPage = () => {
  const { copy } = useLanguage();
  const policy = copy.privacyPolicy;

  return (
    <div className="legal-page" data-testid="privacy-policy-page">
      <div className="container legal-container">
        <div className="legal-header">
          <p className="section-kicker" data-testid="privacy-policy-kicker">
            {policy.kicker}
          </p>
          <h1 className="section-title" data-testid="privacy-policy-title">
            {policy.title}
          </h1>
          <p className="section-text" data-testid="privacy-policy-intro">
            {policy.intro}
          </p>
        </div>

        <div className="legal-section" data-testid="privacy-policy-identity">
          <h2>{policy.identity.title}</h2>
          <p>{policy.identity.body}</p>
          <ul>
            <li>{policy.identity.company}</li>
            <li>{policy.identity.contact}</li>
            <li>{policy.identity.host}</li>
          </ul>
        </div>

        <div className="legal-section" data-testid="privacy-policy-data">
          <h2>{policy.data.title}</h2>
          <p>{policy.data.body}</p>
          <ul>
            {policy.data.items.map((item, index) => (
              <li key={`data-${index}`}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="legal-section" data-testid="privacy-policy-usage">
          <h2>{policy.usage.title}</h2>
          <p>{policy.usage.body}</p>
          <ul>
            {policy.usage.items.map((item, index) => (
              <li key={`usage-${index}`}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="legal-section" data-testid="privacy-policy-services">
          <h2>{policy.services.title}</h2>
          <p>{policy.services.body}</p>
          <ul>
            {policy.services.items.map((item, index) => (
              <li key={`services-${index}`}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="legal-section" data-testid="privacy-policy-rights">
          <h2>{policy.rights.title}</h2>
          <p>{policy.rights.body}</p>
          <ul>
            {policy.rights.items.map((item, index) => (
              <li key={`rights-${index}`}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="legal-section" data-testid="privacy-policy-cookies">
          <h2>{policy.cookies.title}</h2>
          <p>{policy.cookies.body}</p>
          <ul>
            {policy.cookies.items.map((item, index) => (
              <li key={`cookies-${index}`}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="legal-section" data-testid="privacy-policy-contact">
          <h2>{policy.contact.title}</h2>
          <p>{policy.contact.body}</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
